'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _RadioButtonGroup = require('../common/RadioButtonGroup');

var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _commonFormsy = require('../common-formsy');

var _common = require('../common');

var _UpdateRequestButton = require('./UpdateRequestButton');

var _UpdateRequestButton2 = _interopRequireDefault(_UpdateRequestButton);

var _UpdateRequestEmailModule = require('./UpdateRequestEmailModule');

var _UpdateRequestEmailModule2 = _interopRequireDefault(_UpdateRequestEmailModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DROPPED_REASON_OPTIONS = [{ name: 'Our firm dropped this case/plaintiff', value: 'firm' }, { name: 'The plaintiff dropped our firm', value: 'plaintiff' }];

var WrongAttorneyForm = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(WrongAttorneyForm, _Component);

  function WrongAttorneyForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WrongAttorneyForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrongAttorneyForm.__proto__ || Object.getPrototypeOf(WrongAttorneyForm)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'reason', _descriptor, _this), _initDefineProp(_this, 'isLoading', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WrongAttorneyForm, [{
    key: 'createBodyString',
    value: function createBodyString(reason, formData) {
      var body = formData.body,
          lawfirm_name = formData.lawfirm_name,
          response_email = formData.response_email,
          reasonLabel = reason && DROPPED_REASON_OPTIONS.find(function (option) {
        return option.value === reason;
      }).name,
          reasonString = reason ? '\n\n' + reasonLabel : '',
          plaintiffRepresentativeString = lawfirm_name ? '\n\nPlaintiff is now represented by: ' + lawfirm_name : '',
          emailString = response_email ? '\n\nEmail: ' + response_email : '';


      return '' + (body || '') + reasonString + plaintiffRepresentativeString + emailString;
    }
  }, {
    key: 'handleSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
        var _props, attribute, onSubmit, body;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, attribute = _props.attribute, onSubmit = _props.onSubmit, body = this.createBodyString(this.reason, formData);


                this.isLoading.setTrue();
                _context.next = 4;
                return onSubmit(_extends({}, formData, { body: body, tracking_attributes: [attribute], unappendedBody: formData.body }));

              case 4:
                this.isLoading.setFalse();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit(_x) {
        return _ref2.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: 'handleRadioClick',
    value: function handleRadioClick(value) {
      this.reason = value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          attribute = _props2.attribute,
          fromTask = _props2.fromTask;


      return _react2.default.createElement(
        _commonFormsy.Form,
        { className: 'modal-form-style', onValidSubmit: this.handleSubmit },
        attribute === 'attorney_no_longer_represents_plaintiff' && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_RadioButtonGroup2.default, {
            checker: this.reason || '',
            handleRadioClick: this.handleRadioClick,
            items: DROPPED_REASON_OPTIONS,
            fieldName: 'wrong-attorney',
            title: 'I no longer represent this plaintiff because:'
          }),
          this.reason && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_commonFormsy.Input, { name: 'lawfirm_name', label: 'Which firm now represents the case/plaintiff? (optional)' })
          ),
          _react2.default.createElement('hr', null)
        ),
        _react2.default.createElement(_commonFormsy.Textarea, { label: 'Add a note (optional)', name: 'body' }),
        _react2.default.createElement(_common.Spacer, null),
        _react2.default.createElement(_UpdateRequestEmailModule2.default, null),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(_UpdateRequestButton2.default, { disabled: this.isLoading.isTrue, fromTask: fromTask })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return WrongAttorneyForm;
}(_react.Component), _class3.propTypes = {
  attribute: _propTypes2.default.string,
  fromTask: _propTypes2.default.bool,
  onSubmit: _propTypes2.default.func
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'reason', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handleSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleRadioClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleRadioClick'), _class2.prototype)), _class2)) || _class) || _class;

var _default = WrongAttorneyForm;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DROPPED_REASON_OPTIONS, 'DROPPED_REASON_OPTIONS', '/app/src/components/page-tasks/WrongAttorneyForm.js');
  reactHotLoader.register(WrongAttorneyForm, 'WrongAttorneyForm', '/app/src/components/page-tasks/WrongAttorneyForm.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-tasks/WrongAttorneyForm.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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